export default __webpack_public_path__ + "static/media/top_icon.e6129cac.png";